<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Desert King’s Pregnant Bride</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="acknowledgePage" id="ack01"><a id="page06"><p class="acknowledgeText"><span>With warmest gratitude to:<br/>
Leanne McMahon, equine expert extraordinaire;<br/>
Anna Campbell, the best friend a girl could have;<br/>
and my very own hero, Geoff.<br/>
Thank you.<br/>
This book wouldn’t have been<br/>
possible without you!</span></p></a></div>
<a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// desertkingspregnantbridethe_ack01.vue?34c30300